module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-5-9130a100.svg";